import { createSelector } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Model
import { RootState } from "store";

export const selectSnackbarMessage = (state:RootState) => state[Reducers.UI].snackbarMessage;
export const selectTracking = (state:RootState) => state[Reducers.UI].tracking;

export const selectTrackingAdvertClick = createSelector(
  [ selectTracking ],
  ( tracking:any ) => tracking.advertClick
);
